import { useEffect } from "react";

// Replicates the design prototype's vanilla scroll script:
//  - toggles the sticky header's `scrolled` state
//  - reveals `.reveal` elements as they enter the viewport
//  - tracks the active section to highlight the matching nav link
// Implemented as DOM class mutations (rather than React state) so it can
// drive elements that live in sibling components without prop drilling.
const SECTION_IDS = ["work", "experience", "about", "capabilities", "certificates", "contact"];

function ScrollEffects() {
  useEffect(() => {
    const header = document.getElementById("header");
    let ticking = false;

    const update = () => {
      const y = window.scrollY;
      const vh = window.innerHeight;

      // Header
      if (header) header.classList.toggle("scrolled", y > 24);

      // Reveal: element enters once its top crosses 90% of viewport
      document.querySelectorAll(".reveal:not(.in)").forEach((el) => {
        if (el.getBoundingClientRect().top < vh * 0.9) el.classList.add("in");
      });

      // Active nav — section whose top is nearest above mid-viewport
      const navMap = {};
      document.querySelectorAll(".nlink").forEach((a) => {
        navMap[a.dataset.section] = a;
      });
      let current = null;
      const mid = y + vh * 0.42;
      SECTION_IDS.forEach((id) => {
        const s = document.getElementById(id);
        if (s && s.offsetTop <= mid) current = id;
      });
      Object.values(navMap).forEach((a) => a.classList.remove("active"));
      if (current && navMap[current]) navMap[current].classList.add("active");

      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
    const raf = requestAnimationFrame(update);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return null;
}

export default ScrollEffects;
